export default [ '$q', function( $q ) {

	var modifiers = {};
	var env = {};


	this.add = add;
	this.run = run;
	this.setEnv = setEnv;


	function setEnv( key, value ) {

		env[ key ] = value;
	}

	function add( key, fn ) {

		if (!angular.isFunction( fn )) throw new Error( "fn is not typeof Function!" );

		if (!modifiers[ key ]) modifiers[ key ] = [];
		
		modifiers[ key ].push( fn );
	}

	function run( key, args ) {

		if (!modifiers[ key ]) return $q.resolve([]);

		return $q.all( modifiers[ key ].map(function( fn ) {

			return $q.resolve().then(function() {

				return fn( args, env );

			}).catch(function( error ) {
				
				console.error( "showcaseEngineModifier.run( '"+key+"' ) :: Got error:", error );

			});
		}));
	}
}];
